exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".cover__3m8V0{position:absolute;top:0;right:0;bottom:0;left:0;background:hsla(0,0%,100%,.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;z-index:10000}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/common/backdrop-cover/C:/dev/globalTopBar/src/components/common/backdrop-cover/C:/dev/globalTopBar/src/components/common/backdrop-cover/styles.scss"],"names":[],"mappings":"AAAA,cACE,kBACA,MACA,QACA,SACA,OACA,8BACA,oBAAA,oBAAA,aACA,yBAAA,sBAAA,mBACA,wBAAA,qBAAA,uBACA,aAAc,CACf","file":"styles.scss","sourcesContent":[".cover {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(white, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"cover": "cover__3m8V0"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/common/backdrop-cover/styles.scss
// module id = GTru
// module chunks = 0